import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [documentos, setDocumentos] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DOCUMENTOSIDENTIDAD)
      .then(({ data }) => setDocumentos(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='TIPO DOC' htmlFor='select-tipoDocumento' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-tipoDocumento'
            >
              <option value=''>Seleccionar</option>
              {documentos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
